// Central registry of CMS-editable site copy. Admin overrides live in the
// site_copy collection; anything not overridden falls back to `def` here.

export const COPY_GROUPS = [
  {
    id: "b2b_hero", label: "B2B Home — Hero",
    fields: [
      { key: "b2b.hero.overline", label: "Overline", def: "Content + technology platform" },
      { key: "b2b.hero.title", label: "Main heading (H1)", def: "The selling platform behind independent travel resellers." },
      { key: "b2b.hero.subtitle", label: "Subheading", def: "Sellvago is a travel content and selling platform that enables travel resellers to independently service travellers under their own brand name — not a B2B OTA, and not a booking channel.", multiline: true },
      { key: "b2b.hero.cta1", label: "Primary button", def: "Book a Demo" },
      { key: "b2b.hero.cta2", label: "Secondary button", def: "What is Sellvago?" },
    ],
  },
  {
    id: "b2b_stats", label: "B2B Home — Stats bar",
    fields: [
      { key: "b2b.stat1.v", label: "Stat 1 value", def: "900+" },
      { key: "b2b.stat1.l", label: "Stat 1 label", def: "airlines aggregated" },
      { key: "b2b.stat2.v", label: "Stat 2 value", def: "40+" },
      { key: "b2b.stat2.l", label: "Stat 2 label", def: "fare suppliers" },
      { key: "b2b.stat3.v", label: "Stat 3 value", def: "<2s" },
      { key: "b2b.stat3.l", label: "Stat 3 label", def: "average search response" },
      { key: "b2b.stat4.v", label: "Stat 4 value", def: "24/7" },
      { key: "b2b.stat4.l", label: "Stat 4 label", def: "ticketing desk" },
    ],
  },
  {
    id: "b2b_positioning", label: "B2B Home — Positioning cards",
    fields: [
      { key: "b2b.pos1.title", label: "Card 1 title", def: "What is Sellvago?" },
      { key: "b2b.pos1.text", label: "Card 1 text", def: "A travel content and selling platform for independent resellers.", multiline: true },
      { key: "b2b.pos1.cta", label: "Card 1 link label", def: "Read the answer" },
      { key: "b2b.pos2.title", label: "Card 2 title", def: "Sellvago vs a B2B OTA" },
      { key: "b2b.pos2.text", label: "Card 2 text", def: "A B2B OTA is a supplier. Sellvago is infrastructure for building your own travel business.", multiline: true },
      { key: "b2b.pos2.cta", label: "Card 2 link label", def: "See the difference" },
      { key: "b2b.pos3.title", label: "Card 3 title", def: "How white-label reselling works" },
      { key: "b2b.pos3.text", label: "Card 3 text", def: "You sign up. Sellvago provides the stack. You set the commercial policy. Customers see your brand.", multiline: true },
      { key: "b2b.pos3.cta", label: "Card 3 link label", def: "See how it works" },
      { key: "b2b.pos4.title", label: "Card 4 title", def: "How resellers grow with us" },
      { key: "b2b.pos4.text", label: "Card 4 text", def: "Compete on infrastructure, not headcount. Build an independent business under your own brand.", multiline: true },
      { key: "b2b.pos4.cta", label: "Card 4 link label", def: "Read the growth model" },
    ],
  },
  {
    id: "b2b_value", label: "B2B Home — Value propositions",
    fields: [
      { key: "b2b.why.overline", label: "Section overline", def: "Why Sellvago" },
      { key: "b2b.why.title", label: "Section heading", def: "Everything a travel business needs to sell flights profitably." },
      { key: "b2b.vp1.title", label: "Prop 1 title", def: "Multi-supplier airline content" },
      { key: "b2b.vp1.text", label: "Prop 1 text", def: "One search across GDS, NDC and LCC suppliers. Your agents always quote the sharpest fare in the market.", multiline: true },
      { key: "b2b.vp2.title", label: "Prop 2 title", def: "White-label booking portals" },
      { key: "b2b.vp2.text", label: "Prop 2 text", def: "Launch your own branded B2C or B2B portal in days — powered by Sellvago's engine, sold under your name.", multiline: true },
      { key: "b2b.vp3.title", label: "Prop 3 title", def: "Affiliate enablement" },
      { key: "b2b.vp3.text", label: "Prop 3 text", def: "Monetize your audience with deep links, campaign landing pages and transparent commission tracking.", multiline: true },
      { key: "b2b.vp4.title", label: "Prop 4 title", def: "Instant ticketing" },
      { key: "b2b.vp4.text", label: "Prop 4 text", def: "Search, book and issue in one flow. No queues, no manual PNR handling, no waiting on consolidators.", multiline: true },
      { key: "b2b.vp5.title", label: "Prop 5 title", def: "Flexible payments" },
      { key: "b2b.vp5.text", label: "Prop 5 text", def: "Wallet top-ups, credit lines and pay-per-booking options built for how travel SMEs actually run cashflow.", multiline: true },
      { key: "b2b.vp6.title", label: "Prop 6 title", def: "Human support that answers" },
      { key: "b2b.vp6.text", label: "Prop 6 text", def: "Dedicated account managers plus 24/7 reissue and refund desks. Your emergencies are our emergencies.", multiline: true },
    ],
  },
  {
    id: "b2b_supplier", label: "B2B Home — Supplier content section",
    fields: [
      { key: "b2b.sup.overline", label: "Overline", def: "Supplier Content" },
      { key: "b2b.sup.title", label: "Heading", def: "One integration. The whole market." },
      { key: "b2b.sup.text", label: "Body text", def: "GDS, NDC direct-connects and low-cost carriers unified into a single normalized fare stream. Compare, markup and issue without switching consoles.", multiline: true },
      { key: "b2b.sup.li1", label: "Bullet 1", def: "Live availability across 40+ fare sources" },
      { key: "b2b.sup.li2", label: "Bullet 2", def: "Automated reissue, void and refund workflows" },
      { key: "b2b.sup.li3", label: "Bullet 3", def: "Net, published and private fare support" },
      { key: "b2b.sup.li4", label: "Bullet 4", def: "Route-level markup and commission rules" },
      { key: "b2b.sup.statv", label: "Floating stat value", def: "40+ suppliers" },
      { key: "b2b.sup.statl", label: "Floating stat label", def: "normalized in real time" },
    ],
  },
  {
    id: "b2b_partner", label: "B2B Home — Partner programs section",
    fields: [
      { key: "b2b.par.overline", label: "Overline", def: "Partner Programs" },
      { key: "b2b.par.title", label: "Heading", def: "White-label it. Affiliate it. Or plug in the API." },
      { key: "b2b.par.text", label: "Body text", def: "Choose the model that fits your business today — and switch as you scale. Every model runs on the same engine, the same fares and the same instant ticketing.", multiline: true },
      { key: "b2b.par.btn1", label: "Button 1", def: "White-label Portal" },
      { key: "b2b.par.btn2", label: "Button 2", def: "Affiliate Program" },
    ],
  },
  {
    id: "b2b_testimonials", label: "B2B Home — Testimonials",
    fields: [
      { key: "b2b.tes.overline", label: "Overline", def: "Trusted by travel sellers" },
      { key: "b2b.tes.title", label: "Heading", def: "What partners say" },
      { key: "b2b.tes1.quote", label: "Quote 1", def: "We moved our agency to Sellvago's white-label and doubled ticket volume in a quarter. Fares win, support wins.", multiline: true },
      { key: "b2b.tes1.name", label: "Name 1", def: "Amir R." },
      { key: "b2b.tes1.role", label: "Role 1", def: "Director, SME travel agency" },
      { key: "b2b.tes2.quote", label: "Quote 2", def: "As a freelance agent, the instant ticketing changed everything. I quote in the client's WhatsApp and issue in the same minute.", multiline: true },
      { key: "b2b.tes2.name", label: "Name 2", def: "Sana K." },
      { key: "b2b.tes2.role", label: "Role 2", def: "Freelance travel consultant" },
      { key: "b2b.tes3.quote", label: "Quote 3", def: "The affiliate landing pages convert far better than sending traffic to a generic OTA. Attribution is clean and payouts are on time.", multiline: true },
      { key: "b2b.tes3.name", label: "Name 3", def: "Bilal H." },
      { key: "b2b.tes3.role", label: "Role 3", def: "Travel content creator" },
    ],
  },
  {
    id: "b2b_cta", label: "B2B Home — Bottom CTA",
    fields: [
      { key: "b2b.cta.title", label: "Heading", def: "Ready to sell smarter? Let's talk." },
      { key: "b2b.cta.text", label: "Body text", def: "Tell us about your agency or audience and we'll map the right Sellvago setup — usually live within a week.", multiline: true },
      { key: "b2b.cta.btn1", label: "Button 1", def: "Contact Sales" },
      { key: "b2b.cta.btn2", label: "Button 2", def: "See our consumer storefront" },
    ],
  },
  {
    id: "b2c_hero", label: "Farevault /flights — Hero",
    fields: [
      { key: "b2c.hero.title", label: "Main heading (H1)", def: "Fly for less. Book in minutes." },
      { key: "b2c.hero.subtitle", label: "Subheading", def: "Discounted fares on Emirates, PIA, Qatar Airways and more — compared live across 40+ suppliers.", multiline: true },
      { key: "b2c.trust1", label: "Trust badge 1", def: "Multi-supplier discounted fares" },
      { key: "b2c.trust2", label: "Trust badge 2", def: "Instant e-ticket delivery" },
      { key: "b2c.trust3", label: "Trust badge 3", def: "Real humans on WhatsApp" },
      { key: "b2c.trust4", label: "Trust badge 4", def: "Secure booking engine" },
    ],
  },
  {
    id: "b2c_sections", label: "Farevault /flights — Section headings",
    fields: [
      { key: "b2c.air.overline", label: "Airlines overline", def: "Deals by Airline" },
      { key: "b2c.air.title", label: "Airlines heading", def: "Pick your airline, see today's lowest fares" },
      { key: "b2c.air.subtitle", label: "Airlines subtitle", def: "Dedicated deal pages for the airlines Pakistanis fly most — with baggage info, FAQs and instant search.", multiline: true },
      { key: "b2c.rou.overline", label: "Routes overline", def: "Popular Routes" },
      { key: "b2c.rou.title", label: "Routes heading", def: "Trending routes this month" },
      { key: "b2c.rou.subtitle", label: "Routes subtitle", def: "Live fare tracking on Pakistan's busiest international corridors.", multiline: true },
      { key: "b2c.faq.overline", label: "FAQ overline", def: "Booking Help" },
      { key: "b2c.faq.title", label: "FAQ heading", def: "Frequently asked questions" },
    ],
  },
  {
    id: "b2c_faqs", label: "Farevault /flights — FAQs",
    fields: [
      { key: "b2c.faq1.q", label: "Question 1", def: "How does Farevault get cheaper fares?" },
      { key: "b2c.faq1.a", label: "Answer 1", def: "We're powered by Sellvago, a fare aggregator that compares 40+ airline fare suppliers — including private and consolidator fares not shown on airline websites.", multiline: true },
      { key: "b2c.faq2.q", label: "Question 2", def: "Is my booking confirmed instantly?" },
      { key: "b2c.faq2.a", label: "Answer 2", def: "Yes. Once payment completes in the booking engine, your e-ticket is issued instantly and emailed to you.", multiline: true },
      { key: "b2c.faq3.q", label: "Question 3", def: "What if I need help choosing dates or airlines?" },
      { key: "b2c.faq3.a", label: "Answer 3", def: "Tap the WhatsApp button and our booking team will compare options for you — free of charge, usually within minutes.", multiline: true },
      { key: "b2c.faq4.q", label: "Question 4", def: "Can I pay in PKR?" },
      { key: "b2c.faq4.a", label: "Answer 4", def: "Yes, prices are shown and charged in Pakistani Rupees. International cards are also accepted.", multiline: true },
    ],
  },
];

export const COPY_DEFAULTS = COPY_GROUPS.reduce((acc, g) => {
  g.fields.forEach((f) => { acc[f.key] = f.def; });
  return acc;
}, {});
